import NewExhibitorList from "./NewExhibitorList/NewExhibitorList";

const ExhibitorList = () => {
	return <NewExhibitorList />;
};

export default ExhibitorList;

